import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { API_ENDPOINTS } from "../utils/urls";

const PayOrder: React.FC = () => {
  const [userId, setUserId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhonenumber, setcustomerPhonenumber] = useState("");
  const [postId, setPostId] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [amount, setAmount] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState<string>("PROCESSING...");
  let cashfree: any;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setUserId(params.get("userId") || "");
    setCustomerName(params.get("customer-name") || "");
    setCustomerEmail(params.get("customer-email") || "");
    setcustomerPhonenumber(params.get("customer-number") || "");
    setAmount(parseFloat(params.get("amount") || "0"));
    setSubscriptionId(params.get("subscription-id") || "");
    setPostId(params.get("post-id") || "");
    setTransactionId(params.get("transaction-id") || "");
  }, []);

  // Function to initiate Cashfree payment
  const handlePayment = async () => {
    const orderData = {
      userId,
      amount: amount.toString(),
      name: customerName,
      email: customerEmail,
      phonenumber: customerPhonenumber,
      postId: postId,
      subscriptionId: subscriptionId,
      transactionId: transactionId,
      orderCurrency: "INR",
    };
    const { data } = await axios.post(
      API_ENDPOINTS.CASHFREE.CREATE_NEW_SESSION,
      orderData
    );
    // @ts-ignore
    cashfree = window.Cashfree({
      mode: "production",
    });
    await doPayment(data.data.payment_session_id);
  };
  const doPayment = async (paymentSessionId: string) => {
    const checkoutOptions = {
      paymentSessionId: paymentSessionId,
      redirectTarget: "_modal",
    };

    cashfree
      .checkout(checkoutOptions)
      .then(async (result: any) => {
        if (result.error) {
          toast.error("Something went wrong while processing your request.");
          // console.log(
          //   "User has closed the popup or there is some payment error, Check for Payment Status"
          // );
          // console.log(result.error);
          setPaymentStatus("Failed");
        }
        if (result.redirect) {
          // console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          toast.info(
            "You are safe to close this page, or it will close automatically after 1 minute."
          );
          setTimeout(() => {
            setPaymentStatus("Success");
          }, 5000);
          // Close tab after 1 minute
          setTimeout(() => {
            window.close();
          }, 60000);
        }
      })
      .catch((err: any) => {
        toast.error(err.message);
      });
  };
  useEffect(() => {
    // Automatically trigger payment on mount if amount > 0
    if (amount > 0) {
      handlePayment();
    }
  }, [amount]); // Runs once when amount is read
  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "40px auto",
        padding: "2rem",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        Pay Order
      </h2>

      <div style={{ lineHeight: "1.8", marginBottom: "1.5rem" }}>
        <p>
          <strong>User ID:</strong> {userId}
        </p>
        <p>
          <strong>Customer Name:</strong> {customerName}
        </p>
        <p>
          <strong>Customer Email:</strong> {customerEmail}
        </p>
        <p>
          <strong>Phone Number:</strong> {customerPhonenumber}
        </p>
        <p>
          <strong>Amount:</strong> ₹{amount.toFixed(2)}{" "}
          <span style={{ color: "#888" }}>+ 2% platform fee</span>
        </p>
      </div>

      {paymentStatus && (
        <div
          style={{
            backgroundColor:
              paymentStatus === "Success"
                ? "#e6ffed"
                : paymentStatus === "Failed"
                ? "#ffe6e6"
                : "#fffbe6",
            color: "#333",
            padding: "12px",
            borderRadius: "6px",
            marginBottom: "1.5rem",
            textAlign: "center",
            fontWeight: "500",
          }}
        >
          Payment Status: {paymentStatus}
        </div>
      )}

      <div style={{ fontSize: "14px", color: "#555", textAlign: "center" }}>
        <p>
          For any disputes, please contact{" "}
          <a
            href="mailto:fansclub.owners@gmail.com"
            style={{ color: "#007BFF", textDecoration: "none" }}
          >
            fansclub.owners@gmail.com
          </a>
        </p>
        <p>
          Your transaction ID is <strong>{transactionId}</strong>
        </p>
      </div>
    </div>
  );
};

export default PayOrder;
